import { useLocation } from 'react-router-dom';

import { useAuthentication } from '@zenbusiness/application-commons-authentication';
import { ClickstreamProvider, ClickstreamScene } from '@zenbusiness/application-commons-clickstream';
import { useEnv } from '@zenbusiness/application-commons-env';

import { NAME } from '#client/build-env';
import { getAppSection } from '#client/utils/getAppSection';

export default function ClickstreamWrapper({ children, ...delegated }) {
  const { obo } = useAuthentication();
  const { DEPLOY_ENV, RUDDERSTACK_API_KEY, RUDDERSTACK_API_URL } = useEnv('head-first'); // use MFE values
  const { pathname } = useLocation();

  const section = getAppSection(pathname);
  const systemProperties = {
    channel: 'web',
    displayTheme: 'light',
  };

  return (
    <ClickstreamProvider
      deployEnv={DEPLOY_ENV}
      noop={!!obo}
      rudderstackApiKey={RUDDERSTACK_API_KEY}
      rudderstackApiUrl={RUDDERSTACK_API_URL}
      {...delegated}
      systemProperties={systemProperties}
    >
      <ClickstreamScene appOrigin={NAME} appSection={section} experienceOrigin="dashboard">
        {children}
      </ClickstreamScene>
    </ClickstreamProvider>
  );
}
